import { PERFECT_FIT } from ".";

export type SizeProps = {
  type: string;
  subtype: string;
  locked: boolean;
  dimensions: { width: number; height: number; sqft: number };
  orientation: string;
};

export const sizeDefault: SizeProps = {
  dimensions: {
    height: 9,
    sqft: 0.375,
    width: 6,
  },
  locked: true,
  orientation: "Portrait",
  subtype: "",
  type: PERFECT_FIT,
};
